import type {
  OrganizationAddressSettings,
  OrganizationDetail,
} from "@kontextwerk/control-web-client"
import type { AvailabilityPolicyConfig } from "@kontextwerk/control-web-frame/types/availabilityPolicies"
import { request } from "../client"

export type KehrblattBusinessProfile = {
  organization_id: string
  organization_name: string
  public_name?: string | null
  data_privacy_url?: string | null
  contact_email?: string | null
  contact_phone?: string | null
  public_contact_email?: string | null
  public_contact_phone?: string | null
  presentation_indexing_enabled?: boolean
  address: OrganizationAddressSettings
  timezone?: string | null
  timezone_source?: "country" | "manual" | null
  service_hours?: AvailabilityPolicyConfig | null
}

export type KehrblattBusinessProfileUpdate = {
  public_name?: string | null
  data_privacy_url?: string | null
  contact_email: string
  contact_phone: string
  public_contact_email?: string | null
  public_contact_phone?: string | null
  presentation_indexing_enabled?: boolean
  address: OrganizationAddressSettings
  timezone?: string | null
  service_hours?: AvailabilityPolicyConfig | null
}

export type KehrblattBusinessProfileResponse = {
  profile: KehrblattBusinessProfile
  organization: OrganizationDetail
}

export const fetchOrganizationBusinessProfile = (
  organizationId: string,
): Promise<KehrblattBusinessProfileResponse> =>
  request<KehrblattBusinessProfileResponse>(`/organizations/${organizationId}/business-profile`)

export const updateOrganizationBusinessProfile = (
  organizationId: string,
  payload: KehrblattBusinessProfileUpdate,
): Promise<KehrblattBusinessProfileResponse> =>
  request<KehrblattBusinessProfileResponse>(`/organizations/${organizationId}/business-profile`, {
    method: "PUT",
    body: JSON.stringify(payload),
  })
